import { render, staticRenderFns } from "./StandardShippingResellers.vue?vue&type=template&id=5fce7489&scoped=true"
import script from "./StandardShippingResellers.vue?vue&type=script&lang=js"
export * from "./StandardShippingResellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fce7489",
  null
  
)

export default component.exports